module.exports = __webpack_public_path__ + "static/media/pecho.8b3bbaf4.svg";